export { CatchDetailsTable } from './CatchDetailsTable';
